import { call, put } from 'redux-saga/effects';
import { ApiError, ApiResponse } from 'store/api/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { checkResponse } from 'store/utils';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';
import { HMRCFraudHeaderTest } from '../api';
import {
  hmrcFraudHeaderTestFailure,
  hmrcFraudHeaderTestSuccess,
} from '../actions';
import { HmrcFraudHeaderTestRequestAction } from '../types';

export function* hmrcFraudHeaderTestSaga(
  action: HmrcFraudHeaderTestRequestAction
) {
  try {
    const { connectionId } = action.payload;
    const response: ApiResponse = yield call(HMRCFraudHeaderTest, connectionId);

    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description: response.responseMessage.message,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(
      hmrcFraudHeaderTestSuccess(connectionId, response.data ?? {})
    );
  } catch (error) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(hmrcFraudHeaderTestFailure());
  }
}
